import Vue from 'vue'
import Router from 'vue-router'
import Layout from "@/views/layout/Layout"

Vue.use(Router)

const routes = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/login_with_sso', hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '/',
    name: 'Dashboard',
    component: Layout,
    meta: {title: 'DNSGuard', icon: 'tree'},
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/app/Dashboard'),
        meta: {title: 'Dashboard', icon: 'dashboard'}
      },
    ]
  },
  {
    path: '/app',
    name: 'app',
    component: Layout,
    meta: {title: '应用', icon: 'menu'},
    children: [
      {
        path: '/app/node',
        name: 'node',
        component: () => import('@/views/app/node'),
        meta: {title: '节点管理', icon: 'terminal'}
      },
      {
        path: '/app/node_group',
        name: 'node_group',
        component: () => import('@/views/app/node_group'),
        meta: {title: '节点组', icon: 'test'}
      },
      {
        path: '/app/domain_record',
        name: 'domain_record',
        component: () => import('@/views/app/domain_record'),
        meta: {title: '域名解析', icon: 'form'}
      },
      {
        path: '/app/upstream_proxy',
        name: 'upstream_proxy',
        component: () => import('@/views/app/upstream_proxy'),
        meta: {title: '上游代理', icon: 'bind'}
      },
    ]
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Layout,
    meta: {title: '管理员', icon: 'menu'},
    children: [
      {
        path: '/admin/authorization',
        name: 'Admin',
        component: () => import('@/views/admin/authorization'),
        meta: {title: '用户授权', icon: 'user'}
      },
      {
        path: '/admin/access_control_policy',
        name: 'Admin',
        component: () => import('@/views/admin/access_control_policy'),
        meta: {title: '访问策略', icon: 'password'}
      },
      // {
      //   path: '/admin/tag',
      //   name: 'Admin',
      //   component: () => import('@/views/admin/tag'),
      //   meta: {title: '资源管理', icon: 'tag'}
      // },
      {
        path: '/admin/request_logs',
        name: 'Admin',
        component: () => import('@/views/admin/request_logs'),
        meta: {title: '平台请求日志', icon: 'log'}
      },
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/app/Admin',
    name: 'app',
    hidden: true,
  },
  // {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  mode: 'history', // 后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js